

import { useState, useEffect } from "react"
import { Checkbox, Divider, Tooltip } from "antd"
import { getTranslated } from "../../utils/CommonUtils"
import { useSelector, useDispatch } from "react-redux"
import UMCButton from "../common/UMCButton"
import UMCCheckbox from "../common/UMCCheckbox"
import { InfoCircleFilled } from "@ant-design/icons"
import TextField from "../common/TextField"
import PasswordField from "../common/PasswordField"
import confirmModal from "../common/confirmModal"
import initial_connection from '../../assets/images/initial_connection.svg'
import connection_establishment from '../../assets/images/connection_establishment.svg'
import oxe from "../../assets/images/oxe.svg"
import { DIRECTORY_SYNCHRO_URL} from "../../utils/Config"
import { downloadUMCZipFile } from '../../store/actions/CommonActions'
import {getDiscriminationValue, updateDiscriminationValue} from '../../store/actions/OxeActions'
import { getDirectoryConfigData, deleteDirectoryConfigData } from '../..//store/actions/UUMActions'
import {setContentLoading, setUmcNotification} from '../../store/reducers/CommonReducer'
import { setIsEntraConnectionEstablished } from '../../store/reducers/UUMReducer'
import { CheckOutlined, CloseOutlined } from "@ant-design/icons"
import { setOxeUmcDiscriminator} from "../../store/reducers/OxeReducer"
import { sendGTMEvent } from "../../utils/GTMUtils"


const OxeUmcParameters = () => {

    const dispatch = useDispatch()

    const dict = useSelector((state) => state.common.dict)  
    const directorySynchroConfigData = useSelector((state) => state.uum.directorySynchroConfigData)
    const [isEnabled, setIsEnabled] = useState(false)
    const [directory, setDirectory] = useState(getTranslated(dict, "LABEL_ENTRA_DIRECTORY"))
    const [entraID, setEntraID] = useState("")
    const [password, setPassword] = useState("")
    const [isPasswordTouched, setIsPaswwordTouched] = useState(false)
    const [isPasswordValid, setIsPasswordValid] = useState(false)
    const oxeUmcDiscriminator = useSelector(state => state.oxe.oxeUmcDiscriminator)
    const [discriminatorValue, setDiscriminatorValue] = useState(oxeUmcDiscriminator)

    useEffect(()=>{
        dispatch(setContentLoading(true))
        dispatch(getDiscriminationValue())
        setDiscriminatorValue(oxeUmcDiscriminator)
        dispatch(getDirectoryConfigData())
        dispatch(setIsEntraConnectionEstablished(false))
        // setIsEnabled(false)
        // setIsEnabled(directorySynchroConfigData?.response.length != 0 ? true : false)
    },[])

    useEffect(() => {
        const allValid = Object.values(validations).every((val) => val === true)
        setIsPasswordValid(allValid)
    }, [password])

    useEffect(() => {
        setIsEnabled(directorySynchroConfigData?.response.length !== 0 ? true : false)
    }, [directorySynchroConfigData?.response])

    const mendatoryInstruction = {
        title: getTranslated(dict, "LABEL_ENTRA_DIRECTORY"),
        sections: [
            {
                label:  getTranslated(dict, "LABEL_MENDATORY"),
                fields: [
                    getTranslated(dict, "MSG_MANDATORY_ID"),
                    getTranslated(dict, "MSG_MANDATORY_UPN"),
                    getTranslated(dict, "MSG_MANDATORY_SURNAME"),
                    getTranslated(dict, "MSG_MANDATORY_GIVEN_NAME"),
                    getTranslated(dict, "MSG_MANDATORY_ACTIVE"),
                ]
            },
            {
                label:  getTranslated(dict, "LABEL_OPTIONAL"),
                fields: [
                    getTranslated(dict, "MSG_OPTIONAL_LANGUAGE"),
                    getTranslated(dict, "MSG_OPTIONAL_PHONE_NUMBER"),
                    getTranslated(dict, "MSG_OPTIONAL_PHONE_NUMBER"),
                    getTranslated(dict, 'MSG_OPTIONAL_EX_TEL_NO'),
                    getTranslated(dict, "MSG_OPTIONAL_EX_TEL_NO"),
                    getTranslated(dict, "MSG_OPTIONAL_SITE"),
                ]
            }
        ]
    }

    const deleteFunction = ()=>{
        const url = `${DIRECTORY_SYNCHRO_URL}/directorySynchro/clearConfigData?entraId=${entraID || directorySynchroConfigData?.response[0]?.entraId}`
        // checked={isEnabled}
        dispatch(deleteDirectoryConfigData(url))
            .then(() => {
                dispatch(getDirectoryConfigData())
                setEntraID("")
                setPassword("")
            })
            .catch((error) => console.error("Error while clearing config:", error));
    }

    const handleCheckbox = (checked) => {
        if((!directorySynchroConfigData?.response.length && !checked)){
            setIsEnabled(false)
        } else {
            confirmModal({
                title: (checked) ? getTranslated(dict, "LABEL_INFORMATION") : getTranslated(dict, "LABEL_REMOVE_SCIM_ACCESS") ,
                icon: (checked) ? "icon_information.svg" : "icon_warning.svg",
                okText: getTranslated(dict, "LABEL_ACCEPTED"),
                cancelText: getTranslated(dict, "LABEL_CANCEL"),
                onOk: () => {
                    setIsEnabled(checked)
                    deleteFunction()
                },
                onCancel: () => {
                    // setIsEnabled(isEnabled)
                },
                content: (checked) ?  (directorySynchroConfigData?.response.length != 0)? getTranslated(dict, "LABEL_INFORMATION_DETAILS") : <>
                    {getTranslated(dict, "LABEL_ACTIVIVATE_SCIM_ACCESS_INFO")} <a href="/Terms-and-conditions-UMC.pdf" target="_blank">{getTranslated(dict, "LABEL_TERMS_CONDITION")}</a>
                     <span>{" "}{getTranslated(dict, "LABEL_AND")}{" "}</span>
                    <a href="https://myportal.al-enterprise.com/a4FSZ00000lQnpE2AS" target="_blank">{getTranslated(dict, "LABEL_DATA_PRIVACY")}</a>
                </> : getTranslated(dict, "MSG_CONFIRM"),
                closable: true,
                centered: true,
            })
        } 
    }

    // Password validation 
    const validations = {
        length: password.length >= 14,
        hasLetters: /[A-Z]/.test(password) && (password.match(/[a-zA-Z]/g) || []).length >= 2,
        hasNumbers: (password.match(/[0-9]/g) || []).length >= 2,
        hasSpecial: /[^a-zA-Z0-9]/.test(password),
        noRepeatSeq: !/(.)\1{3,}/.test(password) && !/(0123|1234|2345|3456|4567|5678|6789)/.test(password),
    }

    const handleClear = async () =>{
        setEntraID("")
        setPassword("")
        setIsPaswwordTouched(false)
        setIsPasswordValid(false)      
        confirmModal({
            title: getTranslated(dict, "MSG_GENERATE_URL"),
            icon:  "icon_warning.svg",
            okText: getTranslated(dict, "LABEL_YES"),
            cancelText:  getTranslated(dict, "LABEL_NO"),
            onOk: () => {
                dispatch(setContentLoading(true))
                deleteFunction()
                // const url = `${DIRECTORY_SYNCHRO_URL}/directorySynchro/clearConfigData?entraId=${entraID || directorySynchroConfigData?.response[0]?.entraId}`
                // dispatch(deleteDirectoryConfigData(url))
                //     .then(() => {
                //         dispatch(getDirectoryConfigData())
                //         dispatch(setIsSCIMSynchonased(false))
                //     })
                //     .catch((error) => console.error("Error while clearing config:", error));
            },
            onCancel: () => {
                // setIsEnabled(isEnabled)
            },
            content: getTranslated(dict, "MSG_CONFIRM"),
            closable: true,
            centered: true,
        })
        
    }

    const handleSubmit = async () => {
        // Send GTM event for Directory synchro Save and Download action
        sendGTMEvent({
            event: "umc_directory_synchro",
            action: "DS_activation-Save&Download"
        })

        const url = `${DIRECTORY_SYNCHRO_URL}/file`    
         dispatch(setContentLoading(true))
        try {
            await downloadUMCZipFile({
                directory,
                entraID,
                password,
                url
            })
            dispatch({ type: "DOWNLOAD_SUCCESS" })
            dispatch(setContentLoading(false))
            dispatch(getDirectoryConfigData())
            setIsPasswordValid(false)
            dispatch(setUmcNotification({
                type: "success",
                message: getTranslated(dict, "LABEL_SAVED")
            }))
        } catch (error) {
            dispatch(setUmcNotification({
                type: "error",
                message: getTranslated(dict, "LABEL_FAILED"),
            }))
            console.error("Download failed:", error)
            dispatch({ type: "DOWNLOAD_FAILURE", error: error.message })
            dispatch(setContentLoading(false))
            
        }
    }

    const handleReset =()=>{
        dispatch(setContentLoading(true))
        dispatch(setOxeUmcDiscriminator(!discriminatorValue))
        dispatch(updateDiscriminationValue(oxeUmcDiscriminator))

        // Send GTM event for discrimination reset action
        sendGTMEvent({
            event: "umc_system_configuration",
            action: "Reset UMC discrimination"
        })
    }

    // State updation based on the user input
    const updateEntraID = (value) => {
        setEntraID(value)
    }

    const updatePassword = (value) => {
        if (!isPasswordTouched) {
            setIsPaswwordTouched(true)
        } else if (value === "") { setIsPaswwordTouched(false) }
        setPassword(value)
    }

    const updateDirectory = (value) => {
        setDirectory(value)
    }

    return (
        <>
            <div className="oxe-info-tab">
                <Divider orientation="left" orientationMargin="0" plain>{getTranslated(dict, "LABEL_DISCRIMINATION")}</Divider>
                <div className="attr-block" style={{ paddingBottom: "30px" }} >
                    <span className="attr-label"> {getTranslated(dict, "PARAM_DISCRIMINATION_CREATED_BY_UMC")} :</span>
                    <span className="attr-value">{(oxeUmcDiscriminator ==="1")?"Yes": "No"} </span>
                    <UMCButton label={getTranslated(dict, "PARAM_RESET" )} type="primary" className="cont-header-btn" onClick={()=>handleReset()} 
                    disabled = {oxeUmcDiscriminator != "1"}
                        ></UMCButton>
                </div>
            </div>
            <div>
                <div className="oxe-info-tab">
                    <Divider orientation="left" orientationMargin="0" plain>{getTranslated(dict, "LABEL_DIRECTORY_SYNCHRONIZATION")}</Divider>
                    <div style={{ display: "flex" }}>
                        <Checkbox
                            checked={isEnabled}
                            onChange={(event) => handleCheckbox(event?.target?.checked)}
                        >
                            {getTranslated(dict, "LABEL_DS_SCIM")}
                        </Checkbox>
                        <Tooltip title={getTranslated(dict, "TOOLTIP_DIR_SYNC")}>
                            <InfoCircleFilled className="radio-info-icon" role="icon" />
                        </Tooltip>

                    </div>
                    <div>
                         <div className="dir-sync-uses"><span >{getTranslated(dict, "MSG_DIRSYNCHRO_USAGE")}</span></div>
                    </div>
                    {(isEnabled)?
                        <>
                            <div className="att-flex" style={{ marginLeft: "20px", marginTop: "15px" }} >
                                <div className="attr-block" style={{ flex:1, marginRight: "120px" }}>
                                    <div className="attr-block">
                                        <div className="oxe-att-wrapper" style={{ marginBottom: "10px" }}>
                                            <span style={{ flex: 1 }}>
                                                <TextField
                                                    value={directory}
                                                    handleChange={updateDirectory}
                                                    placeholder= {getTranslated(dict, "LABEL_ENTRA_DIRECTORY")}
                                                    id="Entra directory"
                                                    isReadOnly={true}
                                                />
                                            </span>
                                            <Tooltip title="SCIM directory application">
                                                <InfoCircleFilled className="radio-info-icon" role="icon" />
                                            </Tooltip>
                                        </div>

                                        <span className="attr-label">{"Entra ID"}</span>
                                        <div className="oxe-att-wrapper" style={{ marginBottom: "10px" }}>
                                            <span style={{ flex: 1 }}>
                                                <TextField
                                                    value={directorySynchroConfigData?.response[0]?.entraId || entraID}
                                                    handleChange={updateEntraID}
                                                    placeholder= {getTranslated(dict, "PH_ENTRA_ID")}
                                                    id="entraID"
                                                                                                      
                                                />
                                            </span>
                                            <Tooltip title="Id of the directory tenant">
                                                <InfoCircleFilled className="radio-info-icon" role="icon" />
                                            </Tooltip>
                                        </div>
                                    {(directorySynchroConfigData?.response.length === 0)?
                                    <>
                                        <span className="attr-label">{"Password"}</span>
                                        <div className="oxe-att-wrapper" style={{ marginBottom: "10px" }}>
                                            <span style={{ flex: 1 }}>
                                                <PasswordField
                                                    value={password}
                                                    handleChange={updatePassword}
                                                    placeholder={(entraID)?  getTranslated(dict, "PH_ENTRA_ID_PASS"): ""} 
                                                    id="password"
                                                    isReadOnly={(entraID)? false: true}  
                                                />
                                            </span>
                                        </div>
                                    </>
                                        : <></>
                                    }

                                        {/* Password Rules */}
                                    {(directorySynchroConfigData?.response.length === 0 )?
                                         <div className="oxe-att-wrapper" style={{ marginBottom: "10px"}}>
                                        <ul style={{ marginTop: 16, paddingLeft: 20 }}>
                                            <span
                                                style={{
                                                    color: !isPasswordTouched ? "purple" : validations.length ? "green" : "red",
                                                    display: isPasswordTouched ? "flex" : "list-item", 
                                                    gap: isPasswordTouched ? 8 : 0,
                                                   
                                                }}
                                            >
                                                {isPasswordTouched && (validations.length ? <CheckOutlined  /> : <CloseOutlined />)}
                                                {getTranslated(dict, "LABEL_LENGTHVALIDATION")}
                                            </span>

                                            <li
                                                style={{
                                                    color: !isPasswordTouched ? "purple" : validations.hasLetters ? "green" : "red",
                                                    display: isPasswordTouched ? "flex" : "list-item",
                                                    gap: isPasswordTouched ? 8 : 0,
                                                }}
                                            >
                                                {isPasswordTouched && (validations.hasLetters ? <CheckOutlined /> : <CloseOutlined />)}
                                                {getTranslated(dict, "LABEL_CHARVALIDATION")}
                                            </li>

                                            <li
                                                style={{
                                                    color: !isPasswordTouched ? "purple" : validations.hasNumbers ? "green" : "red",
                                                    display: isPasswordTouched ? "flex" : "list-item",
                                                    gap: isPasswordTouched ? 8 : 0,
                                                }}
                                            >
                                                {isPasswordTouched && (validations.hasNumbers ? <CheckOutlined /> : <CloseOutlined />)}
                                                {getTranslated(dict, "LABEL_NUMBERVALIDAION")}
                                            </li>

                                            <li
                                                style={{
                                                    color: !isPasswordTouched ? "purple" : validations.hasSpecial ? "green" : "red",
                                                    display: isPasswordTouched ? "flex" : "list-item",
                                                    gap: isPasswordTouched ? 8 : 0,
                                                }}
                                            >
                                                {isPasswordTouched && (validations.hasSpecial ? <CheckOutlined /> : <CloseOutlined />)}
                                                {getTranslated(dict, "LABEL_SPECIALCHARVALIDATION")}
                                            </li>

                                            <li
                                                style={{
                                                    color: !isPasswordTouched ? "purple" : validations.noRepeatSeq ? "green" : "red",
                                                    display: isPasswordTouched ? "flex" : "list-item",
                                                    gap: isPasswordTouched ? 8 : 0,
                                                }}
                                            >
                                                {isPasswordTouched && (validations.noRepeatSeq ? <CheckOutlined /> : <CloseOutlined />)}
                                                {getTranslated(dict, "LABEL_NONREPETATIONVALIDATION")}
                                            </li>
                                        </ul>
                                        </div>
                                        : <></>
                                    }
                                        {(directorySynchroConfigData?.response.length != 0 ? <UMCButton danger type="primary" onClick={()=>handleClear()} >{getTranslated(dict, "LABEL_CLEAR")}</UMCButton> : "")}
                                    </div>
                                </div>


                                <div className="oxe-info-tab attr-block" style={{flex:1, marginRight: "80px" }}>
                                    {/* Image plane */}
                                    <div style={{ flex: 1, position: "relative", objectFit: "contain" }}>
                                        {/* first div for image */}
                                        <img src={(directorySynchroConfigData?.response.length != 0)? connection_establishment: initial_connection}  ></img>
                                    </div>

                                    <div style={{display:"flex"}}>
                                        {/* second div for image  */}
                                        <div style={{flex:9, color: "#004ECC", fontSize: "10px" }}>
                                            <div>
                                                <div style={{ fontSize: "13px" }}>
                                                    <b>{mendatoryInstruction.title}</b>
                                                </div>
                                                {mendatoryInstruction.sections.map((section, index) => (
                                                    <div key={index}>
                                                        <span style={{ fontSize: "12px" }}>
                                                            <b>{section.label}:</b>
                                                        </span>
                                                        {section.fields.map((field, i) => (
                                                            <div key={i}>- {field}</div>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        <div style={{
                                            flex:1,
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            position: "relative",  
                                            objectFit: "contain"
                                        }}>
                                            {/* right div */}
                                            <img src={oxe} className="responsive-logo"></img>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div style={{ marginTop:"50px" , alignItems: "center", justifyContent: "center", display: "flex" }}>
                                <UMCButton
                                    onClick={() => handleSubmit()}
                                    type="primary"
                                    disabled={(isPasswordValid) ? false : true}
                                >   {(isPasswordValid) ? getTranslated(dict, "LABEL_SAVE_ENCRP_FILE") : "Save"}</UMCButton>
                            </div>

                        </>
                        : <></>}
                </div>
            </div>
        </>
    )
}

export default OxeUmcParameters
